package com.evoapps.evoshift.ui.start

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.LifecycleResumeEffect
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.viewmodels.StartPathViewModel
import com.evoapps.evoshift.ui.theme.MotionVisibility
import com.evoapps.evoshift.ui.theme.rememberLastNonNull

/**
 * SH-219: the start path card on the owner dashboard, or nothing (not the owner, dismissed, an
 * established workplace). The data is read again each time the dashboard is shown again, so a
 * step done on its screen is ticked on the way back.
 */
@Composable
fun StartPathSection(viewModel: StartPathViewModel, actions: (workplaceId: String) -> StartPathActions) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    LifecycleResumeEffect(viewModel) {
        viewModel.refresh()
        onPauseOrDispose {}
    }
    // SH-247: decided after the dashboard: the card unfolds instead of popping in (and folds away).
    val shown = state.workplaceId?.let { workplaceId -> state.path?.let { workplaceId to it } }
    val last = rememberLastNonNull(shown)
    MotionVisibility(shown != null && last != null) {
        val (workplaceId, path) = last ?: return@MotionVisibility
        StartPathCard(
            path = path,
            actions = actions(workplaceId),
            onSkip = viewModel::skip,
            onResume = viewModel::resume,
            onDismiss = viewModel::dismiss,
            message = state.message
        )
    }
}
